module.exports = __webpack_public_path__ + "img/dc65816.png";